import { PermissionUpdatePage } from '@/features/access/pages/permission/PermissionUpdatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/access/permission/$id/update')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["auth_permissions.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: PermissionUpdatePage,
})
